import { InfoHubLayout } from 'views/InfoHub/Layout'
import SmartSwapView from 'views/InfoHub/SmartSwapView'

/** Markets → Smart Swap (2026-10-06; replaces the PancakeSwap tab). A static route, so it wins over /info/[dex]. */
const SmartSwapPage = () => <SmartSwapView />
SmartSwapPage.Layout = InfoHubLayout
SmartSwapPage.chains = [] // set all
export default SmartSwapPage
